import { useQuery } from '@tanstack/react-query';
import { getSchedulingIntegration } from '../services/api/implementation/impl';
import {
  SCHEDULING_INTEGRATION_QUERY_KEY,
  canScheduleAnything,
  isSchedulingConnected,
  supportsBookingLinks,
  supportsNativeBooking
} from '../utils/schedulingAccess';

/**
 * Builder scheduling connection status.
 *
 * Shared by the Integration page and the lead detail Meetings tab so both read
 * one cache entry rather than each firing their own request. `retry: false`
 * because a 400 here means "not connected", a normal state rather than a
 * transient failure worth retrying.
 */
export function useSchedulingIntegration({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: SCHEDULING_INTEGRATION_QUERY_KEY,
    queryFn: getSchedulingIntegration,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled
  });

  const connected = !query.isError && isSchedulingConnected(query.data);

  return {
    ...query,
    connected,
    provider: query.data?.provider ?? null,
    canBookInApp: !query.isError && supportsNativeBooking(query.data),
    canSendLink: !query.isError && supportsBookingLinks(query.data),
    canSchedule: !query.isError && canScheduleAnything(query.data),
    defaultServiceName: query.data?.defaultServiceName ?? null
  };
}

export default useSchedulingIntegration;
